export default __webpack_public_path__ + "static/media/README.8fa53f8b.md";